import { createContext, useContext, useState, useEffect } from "react";
import { regUses, useTbl } from "../../axios_with_token";

const PdtsContext = createContext();
export function usePdts(){
    return useContext(PdtsContext);
}

export function PdtsProvider({children}){
    const { regUse, isLoading:isPdtsLoading } = regUses();
    const { data:tblPdts } = regUse(useTbl('pdts'));
    const [pdts, setPdts] = useState([]);

    useEffect(_=>{
        setPdts((tblPdts||{}).rcds);
    }, [isPdtsLoading]);

    return <PdtsContext.Provider
        value={{
            aaa:'aaa',
            isPdtsLoading,
            pdts
        }}
    >{children}</PdtsContext.Provider>

}